import { CustomElement, resolve } from 'aurelia';
import { CalendarService } from '../../services';
import template from './app-header.html';

// The page header: the mobile filter-drawer toggle, the title, and the admin/account menus.
// The filter toggle drives CalendarService.filterPanelOpen; the menus are composed as their
// own components (<admin-menu> / <account-menu>) that bind their own services.
export class AppHeaderElement {
  readonly calendar: CalendarService = resolve(CalendarService);
}

export const AppHeader = CustomElement.define({
  name: 'app-header',
  template,
  // Render the <header> in place (no host wrapper) so it stays a direct child of .app-shell.
  containerless: true
}, AppHeaderElement);
